<script setup lang="ts">
const { page } = useContent()

watch(
  () => page.value,
  (p) => {
    if (p) useContentHead(p)
  },
  { immediate: true },
)
</script>

<template>
  <div class="min-h-screen flex flex-col bg-white text-gray-900 dark:bg-gray-950 dark:text-gray-100">
    <SiteHeader />
    <main class="flex-1 w-full">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10 py-6 md:py-8">
        <slot />
      </div>
    </main>
    <AppFooter />
  </div>
</template>
